import {Component} from '@angular/core';

@Component({
    selector:'versionComponent',
     templateUrl:'version.component.html'
})
export class VersionComponent{
    
    currentVersion:string='1.0.0.7';
    compatibleWith:string='1.0.0.7';

}